import { useAuth0 } from '@auth0/auth0-react'
import { useAccessToken } from 'hooks/useAccessToken/useAccessToken'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

type TProps = React.PropsWithChildren<any>

export default function LoginWrapper(props: TProps) {
  const auth0 = useAuth0()
  //   const permissions = useAccessPermissions()
  const [loginTimerElapsed, setLoginTimerElapsed] = useState(false)

  const { isAuthenticated, isLoading, loginWithRedirect } = auth0

  const navigate = useNavigate()
  const hasStartedLoadingRef = useRef(false)

  useEffect(() => {
    // 5 seconds
    setTimeout(() => setLoginTimerElapsed(true), 1000)
  }, [])

  useEffect(() => {
    if (
      loginTimerElapsed &&
      hasStartedLoadingRef.current &&
      !isLoading &&
      !isAuthenticated
    ) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.href,
        },
      })
    }

    if (!isLoading && isAuthenticated) {
      //if first login, check for path and search and nav accordingly
      if (!window.location.pathname && !window.location.search) {
        return
      }

      navigate(`${window.location.pathname}${window.location.search}`)
    }

    if (isLoading) {
      hasStartedLoadingRef.current = true
    }
  }, [isLoading, isAuthenticated, loginTimerElapsed, loginWithRedirect])

  if (isLoading || !isAuthenticated) {
    return <></>
  }

  return props.children
}
